import { BulkMessageService } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/batch/v1/batch.pb';
import { Bulk as BulkMessagingService } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { bindHTTP } from '@frontend/schema';

export const SchemaBulkMessage = bindHTTP(BulkMessageService);
export const SchemaBulkMessagingService = bindHTTP(BulkMessagingService);
